module.exports = {
    RouterMixin: require('./lib/RouterMixin'),
    navigate: require('./lib/navigate')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mini-router/index.js
// module id = 209
// module chunks = 0